'use client'

import styled from "styled-components";
import ReactDatePicker from "react-datepicker";
import { ko } from "date-fns/locale";
import "react-datepicker/dist/react-datepicker.css";

import { useEffect, useState } from "react";

const DateRangePickerSingleStyle = styled.div`
    width: 100%;
    .react-datepicker-wrapper {
        width: 100%;
        max-width: 250px;
    }
    input[type="text"] {
        cursor: pointer;
        height: 35px;
        width: 100%;
        padding: 10px;
        padding-right: 36px;
        font-size: 16px;
        color: #3b3b3b;
        border: 1px solid #d3d3d3;
        border-radius: 4px;                
    }
    .react-datepicker__triangle {
        display: none;
    }    
    .react-datepicker__navigation {
        line-height: 0rem;
    }
    .react-datepicker__header {
        padding: 1.1rem 0;
        border-bottom: 1px solid #dedede;
        background-color: #fff;
        .react-datepicker__current-month {
            font-size: 1.2rem;
            font-weight: 500;
            line-height: 1.3rem;
        }
        .react-datepicker__day-names {
            margin-botton: -13px;
            margin-top: 4px;
            .react-datepicker__day-name {
                width: 2.5rem;
                line-height: 2.5rem;
                font-size: 1.1rem;
                color: #999;
            }
        }
    }
    .react-datepicker__month-container {
        float: inherit;
    }
    .react-datepicker__month {
        .react-datepicker__day-name,
        .react-datepicker__day,
        .react-datepicker__time-name {
            line-height: 2.5rem;
            width: 2.5rem;
            font-size: 1.1rem;
        }
    }
    .react-datepicker__day--selected,
    .react-datepicker__day--in-selecting-range,
    .react-datepicker__day--in-range,
    .react-datepicker__month-text--selected,
    .react-datepicker__month-text--in-selecting-range,
    .react-datepicker__month-text--in-range,
    .react-datepicker__quarter-text--selected,
    .react-datepicker__quarter-text--in-selecting-range,
    .react-datepicker__quarter-text--in-range,
    .react-datepicker__year-text--selected,
    .react-datepicker__year-text--in-selecting-range,
    .react-datepicker__year-text--in-range {
        background-color: ${({ theme }) => theme.colors.red};
    }
    .react-datepicker__day--in-range,
    .react-datepicker__month-text--in-range,
    .react-datepicker__quarter-text--in-range,
    .react-datepicker__year-text--in-range {
        background-color: #8172d4;
    }
    .react-datepicker__year-read-view--down-arrow,
    .react-datepicker__month-read-view--down-arrow,
    .react-datepicker__month-year-read-view--down-arrow,
    .react-datepicker__navigation-icon::before {
        width: 6px;
        height: 6px;
        border-width: 2px 2px 0 0;
        border-color: #999;
        top: 8px;
    }
    .react-datepicker__day--outside-month {
        color: #999;
    }
`;

const toDate = (value) => {
    if (!value) return null;
    if (value instanceof Date) return value;
    if (typeof value === "string") {
        const datePart = value.split(" ")[0];
        const chunks = datePart.split("-");
        if (chunks.length === 3) {
            const year = Number(chunks[0]);
            const month = Number(chunks[1]);
            const day = Number(chunks[2]);
            if (!Number.isNaN(year) && !Number.isNaN(month) && !Number.isNaN(day)) {
                return new Date(year, month - 1, day);
            }
        }
    }
    return null;
};

const toDateString = (date) => {
    if (!date) return "";
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
};

function DateRangePickerSingle({
    name,
    startName = "startDate",
    endName = "endDate",
    startDate,
    endDate,
    onChangeValue,
    placeholder = "YYYY-MM-DD - YYYY-MM-DD",
    disabled,
    className,
}) {
    const [selectedRange, setSelectedRange] = useState([toDate(startDate), toDate(endDate)]);

    useEffect(() => {
        setSelectedRange([toDate(startDate), toDate(endDate)]);
    }, [startDate, endDate]);

    const handleDateRangeChange = (dates) => {
        const [start, end] = dates;
        setSelectedRange(dates);

        if (!onChangeValue) return;

        const startValue = toDateString(start);
        const endValue = toDateString(end);

        onChangeValue({ target: { name: startName, value: startValue } });
        onChangeValue({ target: { name: endName, value: endValue } });

        if (name) {
            onChangeValue({
                target: {
                    name,
                    value: {
                        startDate: startValue,
                        endDate: endValue,
                    },
                },
            });
        }
    };

    return (
        <DateRangePickerSingleStyle className={className}>
            <ReactDatePicker
                selected={selectedRange[0]}
                onChange={handleDateRangeChange}
                startDate={selectedRange[0]}
                endDate={selectedRange[1]}
                selectsRange
                locale={ko}
                dateFormat="yyyy-MM-dd"
                dateFormatCalendar="yyyy-MM"
                dropdownMode="select"
                placeholderText={placeholder}
                disabled={disabled}
                isClearable
            />
        </DateRangePickerSingleStyle>
    );
}

export default DateRangePickerSingle;
